import React from 'react';
import loadable from '@loadable/component';

const TextEditorDraft = loadable(() => import('./TextEditorDraft.js'));
import TextEditorGenerator from './TextEditorGenerator';


function TextEditor(props) {
      
  const {
    isEditor,
    isEditable,
    isCurrent,
    isPreview,
  } = props;

  if (isEditor && isEditable && isCurrent || isPreview) {
    return (
      <TextEditorDraft
        {...props}
        editable={isPreview ? false : isEditable}
      />
    );
  }

  return (
    <TextEditorGenerator
      {...props}
    />
  );

}


export default TextEditor;
